import { render } from "./LoadersContent.vue?vue&type=template&id=75584ea2"
import script from "./LoadersContent.vue?vue&type=script&lang=js"
export * from "./LoadersContent.vue?vue&type=script&lang=js"

import "./LoadersContent.vue?vue&type=style&index=0&id=75584ea2&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__